@if (!isEmpty(get(tableRow, 'tables', ''))) {
  @for (row of get(tableRow, 'tables.tables', []); track row; let i = $index) {
    <div>
      <section id="rows" class="d-flex flex-column align-items-center container-gridless">
        <div class="category-top-title d-flex flex-row justify-content-center pb-2">
          @if (get(row, 'headline', '')) {
            <h2 class="col-md-7 text-center">
              {{ get(row, "headline", "") }}
            </h2>
          }
        </div>
        <div class="px-2" id="tables-partial" [innerHTML]="get(row, 'table_content', '') | safe: 'html'"></div>
      </section>
    </div>
  }
}
@if (get(tableRow, 'tables.split_line', '')) {
  <hr class="m-0" />
}
